// extracted by mini-css-extract-plugin
export var container = "Invites-module--container--6h7od";
export var noInvites = "Invites-module--noInvites--Vgp+X";